// extracted by mini-css-extract-plugin
module.exports = {"sectionHeader__title":"SectionHeader_sectionHeader__title__NdWcF","sectionHeader__subtitle":"SectionHeader_sectionHeader__subtitle__sz8jT"};